import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "../Layout/index";
import MainWrapper from "../App/MainWrapper";
import { UserRoutes, RolesRoutes, DisbursementRoutes, InstitutionRoutes } from "./routeConstants";
import Dashboard from "../Dashboard";
import PermissionedRoute from "./PermissionedRoute";
import ProtectedRoute from "./ProtectedRoutes";

const Users = () => <Switch>{UserRoutes.enabled && UserRoutes.routes.map((route) => (route.enabled ? <PermissionedRoute key={route.key} exact={route.exact} path={route.path} allowedPermissions={route.permissions} name={route.name} component={route.pageComponent} /> : null))}</Switch>;

const Disbursement = () => (
    <Switch>{DisbursementRoutes.enabled && DisbursementRoutes.routes.map((route) => (route.enabled ? <PermissionedRoute key={route.key} exact={route.exact} path={route.path} allowedPermissions={route.permissions} name={route.name} component={route.pageComponent} /> : null))}</Switch>
);

const Roles = () => <Switch>{RolesRoutes.enabled && RolesRoutes.routes.map((route) => (route.enabled ? <PermissionedRoute key={route.key} exact={route.exact} path={route.path} allowedPermissions={route.permissions} name={route.name} component={route.pageComponent} /> : null))}</Switch>;

const Institution = () => (
    <Switch>{InstitutionRoutes.enabled && InstitutionRoutes.routes.map((route) => (route.enabled ? <PermissionedRoute key={route.key} exact={route.exact} path={route.path} allowedPermissions={route.permissions} name={route.name} component={route.pageComponent} /> : null))}</Switch>
);

const Router = () => (
    <Switch>
        <MainWrapper>
            <main>
                <div>
                    <Layout />
                    <div className="container__wrap">
                        <Route exact path="/" component={Dashboard} />

                        <Route path="/dashboard" component={Dashboard} />
                        <ProtectedRoute path="/users" component={Users} />
                      
                        <ProtectedRoute path="/disbursement" component={Disbursement} />
                        <ProtectedRoute path="/roles" component={Roles} />
                        <ProtectedRoute path="/institution" component={Institution} />
                        <Redirect to="/dashboard" />
                    </div>
                </div>
            </main>
        </MainWrapper>
    </Switch>
);

export default Router;
